import { UploadOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Space,
  Upload,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import moment from 'moment';
import { useState } from 'react';
import { getMyMemberListByName } from '../../api/constlink';
import { BidPackage } from '../../modules/bid-packages';
import { DebounceSelect } from '../common/DebounceSelectComponent';

interface BidPackageCreateUpdateComponentProps {
  enterpriseId: string;
  projectId: string;
  bidPackage?: BidPackage;
  uploadProps: any;
  onFinish: (bidPackage: BidPackage) => void;
  onCancel: () => void;
}

function BidPackageCreateUpdateComponent({
  enterpriseId,
  projectId,
  bidPackage,
  uploadProps,
  onFinish,
  onCancel,
}: BidPackageCreateUpdateComponentProps) {
  const [form] = Form.useForm();

  // const [gongjongOptions, setGongjongOptions] = useState<any>();
  // const [materialVendorTypeOptions, setMaterialVendorTypeOptions] =
  //   useState<any>();
  const [bidPackageManagers, setBidPackageManagers] = useState<any>(
    bidPackage?.bidPackageManagers,
  );

  // useEffect(() => {
  //   let children: any = [];
  //   for (const gongjong of gongjongs) {
  //     children.push(
  //       <Option key={gongjong.id} value={gongjong.name}>
  //         {gongjong.name}
  //       </Option>,
  //     );
  //   }
  //   setGongjongOptions(children);
  //   children = [];
  //   for (const mvt of materialVendorTypes) {
  //     children.push(
  //       <Option key={mvt.id} value={mvt.name}>
  //         {mvt.name}
  //       </Option>,
  //     );
  //   }
  //   setMaterialVendorTypeOptions(children);
  // }, [gongjongs, materialVendorTypes]);

  const dateFormat = 'YYYY-MM-DD';
  let _bidPackage: any, title;

  if (!!bidPackage) {
    title = '수정';
    _bidPackage = {
      ...bidPackage,
      startDate: moment(bidPackage.startDate, dateFormat),
      endDate: moment(bidPackage.endDate, dateFormat),

      /**
       * DB 의 timezone 은 'Asia/Seoul' 임.
       * DatePicker 는 입력된 시간정보가 UTC 로 간주해서 'Asia/Seoul' 로 변환한다(9시간 뺌).
       * 임의로 9시간을 더해 줘야 올바른 시간 정보가 출력된다.
       */
      bidDueDateTime: moment(bidPackage.bidDueDateTime, 'YYYY-MM-DD HH:mm').add(
        9,
        'hours',
      ),
    };
    if (bidPackage.jobWalkDateTime) {
      _bidPackage.jobWalkDateTime = moment(
        bidPackage.jobWalkDateTime,
        'YYYY-MM-DD HH:mm',
      ).add(9, 'hours');
    }
    const bidPackageType = bidPackage.isBudgeting ? '견적' : '입찰';
    title = bidPackageType + ' ' + title;
  } else {
    title = '생성';
    _bidPackage = {
      type1: '1',
    };
  }

  const validateStartDate = (value: string) => {
    if (form.getFieldValue('endDate')) {
      const startDate = new Date(value);
      const endDate = new Date(form.getFieldValue('endDate'));

      if (startDate >= endDate)
        return Promise.reject(
          new Error('공사시작일은 공사종료일보다 빨라야 합니다.'),
        );
    }
    return Promise.resolve();
  };

  const validateEndDate = (value: string) => {
    if (form.getFieldValue('startDate')) {
      const startDate = new Date(form.getFieldValue('startDate'));
      const endDate = new Date(value);
      if (startDate >= endDate)
        return Promise.reject(
          new Error('공사종료일은 공사시작일보다 늦어야 합니다.'),
        );
    }
    return Promise.resolve();
  };

  const validateBidDueDate = (value: string) => {
    if (form.getFieldValue('startDate')) {
      const startDate = new Date(form.getFieldValue('startDate'));
      const bidDueDateTime = new Date(value);
      if (startDate <= bidDueDateTime)
        return Promise.reject(
          new Error('견적마감일은 공사시작일보다 빨라야 합니다.'),
        );
    }
    return Promise.resolve();
  };

  const normFile = (e: any) => {
    let fileList = e.fileList;
    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  return (
    <div>
      <Row>
        <Col span={12}>
          <h1>{title}</h1>
        </Col>
      </Row>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={_bidPackage}
      >
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="name"
              label="공사명"
              rules={[
                {
                  required: true,
                  message: '공사명을 입력하세요.',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="bidPackageManagers"
              label="담당자"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DebounceSelect
                mode="multiple"
                value={bidPackageManagers}
                enterpriseId={enterpriseId}
                projectId={projectId}
                placeholder="담당자를 입력 하세요."
                fetchOptions={getMyMemberListByName}
                onChange={(newData) => {
                  setBidPackageManagers(newData);
                }}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="startDate"
              label="공사시작일"
              rules={[
                {
                  required: true,
                  message: '공사시작일을 선택해 주세요.',
                },
                {
                  validator: (_, value) => validateStartDate(value),
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="endDate"
              label="공사종료일"
              rules={[
                {
                  required: true,
                  message: '공사종료일을 선택해 주세요.',
                },
                {
                  validator: (_, value) => validateEndDate(value),
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="space-between">
          <Col span={11}>
            <Form.Item
              name="bidDueDateTime"
              label="견적마감일"
              rules={[
                {
                  required: true,
                  message: '견적마감일을 선택해 주세요.',
                },
                {
                  validator: (_, value) => validateBidDueDate(value),
                },
              ]}
            >
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item name="isBriefing" valuePropName="checked">
              <Checkbox style={{ width: '100%' }}>
                현장설명회 실시 여부
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.isBriefing !== currentValues.isBriefing
          }
        >
          {({ getFieldValue }) =>
            getFieldValue('isBriefing') === true ? (
              <Row justify="space-between">
                <Col span={11}>
                  <Form.Item name="jobWalkDateTime" label="현장설명회 일시">
                    <DatePicker
                      showTime={{ format: 'HH:mm' }}
                      format="YYYY-MM-DD HH:mm"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col span={11}>
                  <Form.Item
                    name="briefingSite"
                    label="현장설명회 장소"
                    rules={[
                      {
                        required: true,
                        message: '현장설명회 장소를 입력하세요.',
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            ) : null
          }
        </Form.Item>

        <Row justify="space-between">
          <Col span={11}>
            <Form.Item name="instructions" label="주의사항">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              name="attachedFiles"
              label="설계도서"
              valuePropName="fileList"
              getValueFromEvent={normFile}
            >
              <Upload {...uploadProps}>
                <Button icon={<UploadOutlined rev={undefined} />}>
                  파일 올리기
                </Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center">
          <Col>
            <Form.Item>
              <Space size="middle">
                <Button htmlType="button" onClick={onCancel}>
                  취소
                </Button>
                <Button type="primary" htmlType="submit">
                  확인
                </Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default BidPackageCreateUpdateComponent;
